var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefundTit1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.64 6.85986C18.16 8.47986 19.09 10.6599 19.09 13.0499C19.09 18.0499 15.04 22.0899 10.05 22.0899C8.96997 22.0899 7.92997 21.8999 6.96997 21.5499",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35 19.14C1.89 17.53 1 15.4 1 13.06C1 8.06002 5.05 4.02002 10.04 4.02002C11.12 4.02002 12.16 4.21002 13.13 4.56002",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81996 25.5299L6.95996 21.5599L10.93 18.6899",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.27 0.580078L13.13 4.56008L9.16003 7.42008",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefundTit1);
export default __webpack_public_path__ + "static/media/icon_refund_tit1.4117af383933efdda8290e75ffbce081.svg";
export { ForwardRef as ReactComponent };